import React from "react";
import "../../../styles/auth.css";

const FormAlert = ({ type, message }) => {
  if (!message) return null;

  return <div className={`alert alert-${type}`}>{message}</div>;
};

export default FormAlert;
